import Fetch from '../Fetch';

export default {
  queryMulticastList: (params) => {
    return Fetch.get(`/api/v1/multicast_groups`, { params });
  },

  queryMulticastModeInfo: () => {
    return Fetch.get(`/api/v1/multicast_mode`);
  },

  queryMulticastBlockAddressInfo: () => {
    return Fetch.get(`/api/v1/multicast_block_address`);
  },

  updateMulticastMode: (params) => {
    return Fetch.post(`/api/v1/multicast_mode`, params);
  },

  updateMulticastBlockAddress: (params) => {
    return Fetch.post(`/api/v1/multicast_block_address`, params);
  },
};
